import { graphql } from '@/generated/gql';

export const INTAKE_QUOTE_ANALYSIS = graphql(/* GraphQL */ `
  query IntakeQuoteAnaylsis($id: UUID!) {
    sevenbridges {
      chatSession(id: $id) {
        id
        status
        analysis {
          id
          fileId
          status
        }
      }
    }
  }
`);
